import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ContractsListPage from "./pages/ContractsListPage";
import UploadContractPage from "./pages/UploadContractPage";
import ContractTypesPage from "./pages/ContractTypesPage";
import ContractChatPage from "./pages/ContractChatPage";
import DashboardPage from "./pages/DashboardPage";
import SsoCallbackPage from "./pages/SsoCallbackPage";
import SsoLoginPage from "./pages/SsoLoginPage";
import ForceResetPage from "./pages/ForceResetPage";
import ProposalReviewPage from "./pages/ProposalReviewPage";
import ProposalUploadPage from "./pages/ProposalUploadPage";
import ProposalChatPage from "./pages/ProposalChatPage";
import { buildUserFromToken, storeAuthFromToken } from "./utils/auth";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const incomingToken = params.get("token");
    if (incomingToken) {
      const nextUser = storeAuthFromToken(incomingToken);
      if (nextUser) setUser(nextUser);
      window.history.replaceState({}, "", window.location.pathname);
      return;
    }

    const stored = localStorage.getItem("user");
    if (stored) {
      try {
        setUser(JSON.parse(stored));
        return;
      } catch (_) {
        /* ignore */
      }
    }

    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      const nextUser = buildUserFromToken(storedToken);
      if (nextUser) {
        localStorage.setItem("user", JSON.stringify(nextUser));
        setUser(nextUser);
      }
    }
  }, []);

  const handleAuth = (u) => {
    setUser(u);
  };

  const hasToken = Boolean(user || localStorage.getItem("token"));
  const hasIncomingToken = Boolean(new URLSearchParams(window.location.search).get("token"));

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            hasIncomingToken ? (
              <SsoCallbackPage onAuth={handleAuth} />
            ) : (
              <Navigate to={hasToken ? "/dashboard" : "/sso"} replace />
            )
          }
        />
        <Route path="/sso/callback" element={<SsoCallbackPage onAuth={handleAuth} />} />
        <Route path="/force-reset" element={<ForceResetPage onAuth={handleAuth} />} />
        <Route
          path="/sso"
          element={
            hasIncomingToken ? (
              <SsoCallbackPage onAuth={handleAuth} />
            ) : hasToken ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <SsoLoginPage onAuth={handleAuth} />
            )
          }
        />
        <Route
          path="/*"
          element={
            hasToken ? (
              <Layout user={user} onAuth={handleAuth}>
                <Routes>
                  <Route path="/dashboard" element={<DashboardPage user={user} />} />
                  <Route path="/contracts" element={<ContractsListPage user={user} />} />
                  <Route path="/contracts/new" element={<UploadContractPage user={user} />} />
                  <Route path="/contract-types" element={<ContractTypesPage user={user} />} />
                  <Route path="/contracts/:id/chat" element={<ContractChatPage />} />
                  <Route path="/proposals" element={<ProposalReviewPage user={user} />} />
                  <Route path="/proposals/new" element={<ProposalUploadPage user={user} />} />
                  <Route path="/proposals/:id/chat" element={<ProposalChatPage />} />
                </Routes>
              </Layout>
            ) : (
              <Navigate to="/sso" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
